import { useState } from "react";
import type { ExamStatus } from "@mubin/contracts";
import { ExamsCard, examStatusLabel } from "../components/exams";
import { PageTitle, Tabs } from "../components/ui";

type View = ExamStatus | "mine";

/**
 * Exams (docs/09 §2): sittings across the caller's scope by status, so results waiting for approval
 * are handled in one place. Scheduling stays on the student's page, where the enrollment is known.
 */
export function ExamsPage() {
  const [view, setView] = useState<View>("recorded");
  const query = view === "mine" ? "mine=examiner" : `status=${view}`;
  return (
    <>
      <PageTitle
        title="الاختبارات"
        sub="الاختبارات الرسمية ضمن نطاقك. تُجدول من صفحة الطالب، وتُعتمد نتائجها من هنا أو من صفحته."
      />
      <Tabs<View>
        label="حالة الاختبار"
        value={view}
        onChange={setView}
        items={[
          { value: "recorded", label: examStatusLabel.recorded },
          { value: "scheduled", label: examStatusLabel.scheduled },
          { value: "approved", label: examStatusLabel.approved },
          { value: "cancelled", label: examStatusLabel.cancelled },
          { value: "mine", label: "أختبرها أنا" },
        ]}
      />
      <ExamsCard
        query={query}
        showStudent
        title={view === "mine" ? "أختبرها أنا" : examStatusLabel[view]}
        empty={view === "recorded" ? "لا نتائج بانتظار الاعتماد" : "لا اختبارات هنا"}
      />
    </>
  );
}
